<div data-testid="div-main-mesage-container" [ngClass]="[overlay === true?'overlay-container-custom':'']" (click)="removeMsg()">
  @for (item of notifications; track item) {
    <div data-testid="div-toaster-message-item" id="toast-container" class="toast-center-custom">
      <div data-testid="div-toaster-message" [ngClass]="[item.message !== undefined ?'show':'hidden']" class="toast {{cssClass(item) }}" aria-live="polite">
        <button data-testid="btn-remove-noitification" type="button" class="toast-close-button" role="button" (click)="removeNotification(item)">×</button>
        <div data-testid="div-toaster-message-text" class="toast-message" [innerHTML]="item.message">
        </div>
      </div>
    </div>
  }
</div>

